'use strict';

const _ = require('lodash');
const moment = require('moment');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');

module.exports = (input, config) => {
    _.defaults(config, {
        required: false,
        min: undefined,
        max: undefined,
        lang: 'en',
    });

    if (config.required && _.isNil(input)) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    let date = undefined;
    if (!_.isNil(input)) {
        if (!input.match(/^(\d{4})-(\d{2})-(\d{2})$/)) {
            throw new ParserError(PARSER_ERRORS.NOT_DATE);
        }

        date = moment.utc(input, 'YYYY-MM-DD');

        if (!date.isValid()) {
            throw new ParserError(PARSER_ERRORS.NOT_DATE);
        }
        date = date.toDate();

        if (!_.isNil(config.min) && date.getTime() < (new Date(config.min)).getTime()) {
            throw new ParserError(PARSER_ERRORS.MIN_DATE, [{min: moment(config.min).locale(config.lang).format('LL')}]);
        }
        if (!_.isNil(config.max) && date.getTime() > (new Date(config.max)).getTime()) {
            throw new ParserError(PARSER_ERRORS.MAX_DATE, [{max: moment(config.max).locale(config.lang).format('LL')}]);
        }
    }

    return date;
};
